import { useGetProductsToHideQuery } from "@/api/reduxToolkit/contentfulData";

export const useGetProductsToHide = () => useGetProductsToHideQuery()